import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { PropertyDocumentSource } from '@barthauer/abc/common-editors';
import { ICoreDataEntity } from '@barthauer/abc/core/data';
import { Observable, Subscription } from 'rxjs';
import { AbcArenaService, DataFormStyle, LayoutUsage, LoadLayoutStatus } from './abc-arena.service';
import { ArenaComponent } from './core/arena.component';
import { ArenaService } from './core/arena.service';
import { AdditionalHigonAction } from './core/higon/higon.model';
import { AdditionalMenuItem } from './core/menu/menu.model';
import { CRUDPermissions } from './core/models/layout.model';
import { IArenaPlugin } from './plugins/arena-plugin.model';
import { AdditionalMenuSettingItem } from './core/settings/setting.model';

@Component({
  selector: 'abc-arena',
  template: `<arena-container
    #arenaContainer
    [uiconfig]="{
      component: {
        dataform: renderDataForm,
        drawer: renderDrawer,
        header: renderHeader,
        higna: renderHigna,
        hignabuttons: renderHignaButtons,
        higon: renderHigon,
        menu: renderMenu,
        navigation: renderNavigation,
        standalone: isStandaloneDataForm,
      },
      arenaName: arenaName,
      dataFormStyle: dataFormStyle,
      layoutSplitterOrientation: layoutSplitterOrientation,
      propertyDocumentSource: propertyDocumentSource,
      helpUrl: helpUrl,
    }"
    [context]="{
      layoutUsage: layoutUsage,
      defaultObjectType: defaultObjectType,
    }"
    [plugins]="plugins"
    (onObjectsSelected)="objectsSelected($event)"
  >
  </arena-container> `,
  styles: [],
  standalone: false,
})
export class AbcArenaComponent implements OnInit {
  @ViewChild('arenaContainer', { static: true }) public arena: ArenaComponent;
  @Input() renderNavigation = true;
  @Input() renderMenu = true;
  @Input() renderDataForm = true;
  @Input() renderHigna = true;
  @Input() renderHigon = true;
  @Input() arenaName: string;
  @Input() renderHeader = true;
  @Input() renderDrawer = true;
  @Input() isStandaloneDataForm = false;
  @Input() layoutUsage: LayoutUsage = LayoutUsage.Standard;
  @Input() defaultObjectType: string | number;
  @Input() helpUrl: string;
  @Input() dataFormStyle: DataFormStyle;
  @Input() layoutSplitterOrientation: 'horizontal' | 'vertical';
  @Input()
  plugins: IArenaPlugin[];

  @Input() get crudPermissions(): CRUDPermissions {
    return this.abcArenaService.crudPermissions;
  }
  set crudPermissions(value: CRUDPermissions) {
    this.abcArenaService.crudPermissions = value;
  }
  @Input() renderHignaButtons: boolean;
  @Input()
  get additionalHigonActions(): AdditionalHigonAction[] {
    return this.abcArenaService.additionalHigonActions;
  }
  set additionalHigonActions(actions: AdditionalHigonAction[]) {
    this.abcArenaService.additionalHigonActions = actions;
  }
  @Input()
  get additionalMenuActions(): AdditionalMenuItem[] {
    return this.abcArenaService.additionalMenuActions;
  }
  set additionalMenuActions(actions: AdditionalMenuItem[]) {
    this.abcArenaService.additionalMenuActions = actions;
  }
  @Input()
  get additionalMenuSettingItems(): AdditionalMenuSettingItem[] {
    return this.abcArenaService.additionalMenuSettingItems;
  }
  set additionalMenuSettingItems(actions: AdditionalMenuSettingItem[]) {
    this.abcArenaService.additionalMenuSettingItems = actions;
  }
  @Input() get disableNotification(): boolean {
    return this.abcArenaService.disableNotification;
  }
  set disableNotification(value: boolean) {
    this.abcArenaService.disableNotification = value;
  }

  @Input() propertyDocumentSource: PropertyDocumentSource;
  private subscriptions: Subscription[] = [];
  public arenaStatus$: Observable<LoadLayoutStatus>;

  @Output() onObjectsSelected: EventEmitter<ICoreDataEntity[]> = new EventEmitter();
  public beforeLogoutFunc: () => void;

  constructor(
    private arenaService: ArenaService,
    private abcArenaService: AbcArenaService,
  ) {
    this.arenaStatus$ = this.abcArenaService?.arenaStatus$;
  }

  objectsSelected(dataEntities: ICoreDataEntity[]) {
    this.onObjectsSelected.emit(dataEntities);
  }

  ngOnDestroy(): void {
    this.subscriptions?.forEach((subscribtion) => subscribtion.unsubscribe());
  }

  async ngOnInit(): Promise<void> {
    this.arena.beforeLogoutFunc = this.beforeLogoutFunc;
  }

  public openLayoutByObjectType(arenaName: string, objectType: number | string, idList: string[]): void {
    this.arenaService.openLayoutByObjectType(arenaName, objectType, idList);
  }

  public openLayoutByPath(arenaName: string, layoutPath: string, idList?: string[]) {
    this.arenaService.loadGroupOrLayout(arenaName ?? this.arenaName ?? this.arenaService.arenaName, layoutPath, idList);
  }

  public async openNavigationGroupByName(groupName: string): Promise<boolean> {
    return await this.arena.openNavigationGroupByName(groupName);
  }
}
